export interface AuthSessionClaims {
  readonly assuranceLevel: 'aal1' | 'aal2' | null;
  readonly sessionId: string | null;
  readonly subject: string | null;
}

/** Decode identity claims from a Supabase access token without treating them as server proof. */
export function readAuthSessionClaims(accessToken: string): AuthSessionClaims | null {
  try {
    const segment = accessToken.split('.')[1];
    if (!segment) {
      return null;
    }
    const base64 = segment.replaceAll('-', '+').replaceAll('_', '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const claims = JSON.parse(globalThis.atob(padded)) as Record<string, unknown>;
    return {
      assuranceLevel: claims.aal === 'aal1' || claims.aal === 'aal2' ? claims.aal : null,
      sessionId:
        typeof claims.session_id === 'string' && claims.session_id !== ''
          ? claims.session_id
          : null,
      subject: typeof claims.sub === 'string' && claims.sub !== '' ? claims.sub : null,
    };
  } catch {
    return null;
  }
}
